<div class="card mb-5 custom-chart-card"
    [style.border]="data.chartConfig?.cardBorder || null">
    <div class="card-header border-0">
        <h2 class="chart-main-title fw-bold text-dark">Price Dynamics</h2>
    </div>

    <div class="year-range-section d-flex align-items-center font-weight-bold">
        <span class="range-label me-3 text-muted">Year Range:</span>
        <div class="range-controls d-flex align-items-center gap-2 p-1 rounded-2 border shadow-sm bg-white">
            <select class="year-select form-select border-0 bg-transparent py-1" [(ngModel)]="startYear"
                (change)="onYearChange()">
                <option *ngFor="let year of getStartYearOptions()" [ngValue]="year">{{year}}</option>
            </select>
            <span class="to-text text-muted small">to</span>
            <select class="year-select form-select border-0 bg-transparent py-1" [(ngModel)]="endYear"
                (change)="onYearChange()">
                <option *ngFor="let year of getEndYearOptions()" [ngValue]="year">{{year}}</option>
            </select>
        </div>
    </div>

    <div class="card-body pt-0">
        <div class="chart-scale-wrap"
            [style.transform]="data.chartConfig?.wrapperScale ? 'scale(' + data.chartConfig.wrapperScale + ')' : null"
            [style.transformOrigin]="data.chartConfig?.wrapperScale ? 'top left' : null"
            [style.width]="data.chartConfig?.wrapperScale ? (100 / data.chartConfig.wrapperScale) + '%' : null">
            <div #chartHost [attr.id]="data.widgetId" [style.height]="data.chartConfig?.height || data.height || '400px'"></div>
        </div>
    </div>
</div>
